import { FC } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Redux
import { useAppSelector } from 'hooks/useStore';
// Selectors
import { selectQuiz } from 'store/quiz/quizSelectors';
import { selectResult } from 'store/player/playerSelectors';
// Models
import IQuiz from 'models/Quiz';
// Components
import { Button } from 'components/Buttons';
// Hooks
import useNavigateTo from 'hooks/useNavigateTo';
import QuizTypes from 'types/QuizTypes';

const LeaderboardButton:FC = () => {
  const { t } = useTranslation();
  const navigateTo = useNavigateTo();

  const quiz:IQuiz = useAppSelector(selectQuiz);
  const result:any = useAppSelector(selectResult);

  const isPollQuiz = [QuizTypes.Poll, QuizTypes.RankingPoll].includes(quiz.type);
  const isScoringQuizzes = [QuizTypes.Scoring, QuizTypes.Prediction, QuizTypes.BeatTheExpert, QuizTypes.Streak].includes(quiz.type);
  const isTeamSelectorQuiz = quiz.type === QuizTypes.TeamSelector;

  const handleClick = () => {
    if (isPollQuiz) {
      navigateTo('results');
    } else if (isTeamSelectorQuiz) {
      navigateTo('teamboard');
    } else {
      navigateTo('leaderboard');
    }
  }

  const label = quiz.callToAction.buttonTitle
    ? quiz.callToAction.buttonTitle
    : isPollQuiz || isTeamSelectorQuiz
      ? t('buttons.results')
      : t('buttons.leaderboard')

  const isDisabled = quiz.resultsPage.enabled && !isPollQuiz && !result;

  if ( [QuizTypes.Personality, QuizTypes.Survey].includes(quiz.type) ) return null;
  if ( !quiz.resultsPage.enabled ) return null;
  return (
    <div className={`z-10 text-center mb-4 ${isScoringQuizzes || isTeamSelectorQuiz ? 'order-1 mt-4' : ''}`}>
      <Button
        className={`
          w-full !text-xl primary-button
          ${isPollQuiz ? 'uppercase' : 'normal-case'}
        `}
        onClick={handleClick}
        disabled={isDisabled}
      >
        {label}
      </Button>
    </div>
  )
}

export default LeaderboardButton;
